import { arrayMergeOverwrite } from "./common";
import { createReducer } from "@reduxjs/toolkit";
import merge from "deepmerge";
import { resetData, setData, setInboxDocumentData, setInboxTaxSummaryData } from "../actions/profile";

const initialState = {
	contactsAddressesErrors: [],
	contactsAddressesIsLoading: false,
	contactsEmailsErrors: [],
	contactsEmailsIsLoading: false,
	contactsPhonesErrors: [],
	contactsPhonesIsLoading: false,
	countryCodes: [],
	data: null,
	inbox: null,
	inboxDocuments: {},
	inboxErrors: [],
	inboxIsLoading: false,
	inboxTaxSummaries: {},
	interfaceErrors: [],
	isAgreeingTerms: false,
	isAgreeingTermsFailed: false,
	isCountryCodesFailed: false,
	isCountryCodesPending: false,
	isCreating: false,
	isCreatingFailed: false,
	isFetching: false,
	isFetchingFailed: false,
	isMaintenanceMode: false,
	isPendingMaintenanceStatus: false,
	isProfileNotFound: false,
	isStateCodesFailed: false,
	isStateCodesPending: false,
	stateCodes: [],
	systemErrors: []
};

const commonReducer = createReducer(initialState, (builder) => {
	builder
		.addCase(resetData, (state, action) => {
			return { ...initialState, ...action.payload };
		})
		.addCase(setData, (state, action) => {
			return merge(state, action.payload, { arrayMerge: arrayMergeOverwrite });
		})
		.addCase(setInboxDocumentData, (state, action) => {
			return merge(state, { inboxDocuments: { ...state.inboxDocuments, ...action.payload } }, { arrayMerge: arrayMergeOverwrite });
		})
		.addCase(setInboxTaxSummaryData, (state, action) => {
			return merge(state, { inboxTaxSummaries: { ...state.inboxTaxSummaries, ...action.payload } }, { arrayMerge: arrayMergeOverwrite });
		});
});

export default commonReducer;